import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import IconLogo from "../components/IconLogo.vue";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#4F46E5",
        secondary: "#374151",
        accent: "#F97316",
        error: "#EF4444",
        warning: "#F59E0B",
        info: "#0EA5E9",
        success: "#22C55E",
        background: "#F8FAFC",
      },
    },
  },
  icons: {
    values: {
      logo: {
        component: IconLogo,
      },
    },
  },
});
